import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2ReturnAccepted = hashCodeCertificate("WaybillV2ReturnAccepted")

export default WaybillV2ReturnAccepted
